import { tabsId } from '../config/ids';
import type { TabsElement } from './types/TabsElement';

export const setTabElements = (tabs: TabsElement[]): void => {
  localStorage.setItem(tabsId, JSON.stringify(tabs));
};
